import access_roles from '@/middleware/pipes/access-roles';
import auth from '@/middleware/pipes/auth';
import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { SocketPagePath } from '@/enums/sockets';
import { Leads } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Leads.Pages.LEADS}`,
    name: Leads.Pages.LEADS,
    component: () => import(/* webpackChunkName: "leads" */ './views/Leads.vue'),
    meta: {
      access_roles: RouteRoles[Leads.Pages.LEADS],
      sockets_path: SocketPagePath.LEADS,
    },
  },
  {
    path: `/${Leads.Pages.LEAD_DETAIL}/:id`,
    name: Leads.Pages.LEAD_DETAIL,
    component: () => import(/* webpackChunkName: "lead-detail" */ './views/LeadDetail.vue'),
    meta: {
      access_roles: RouteRoles[Leads.Pages.LEAD_DETAIL],
      sockets_path: SocketPagePath.LEAD_DETAIL,
    },
  },
];

export default routes;
